import { render, staticRenderFns } from "./horse-table.vue?vue&type=template&id=20bd05fa&"
import script from "./horse-table.vue?vue&type=script&lang=js&"
export * from "./horse-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports